import { api } from './client';

export interface LLMProvider {
  id: number;
  name: string;
  model: string;
  temperature: number;
  is_active: boolean;
  display_name: string;
  created_at: string;
  updated_at: string;
}

interface UpdateProviderRequest {
  model?: string;
  temperature?: number;
}

export const llmProvidersApi = {
  /**
   * Get all LLM providers with is_active populated from app_settings
   */
  list: (): Promise<LLMProvider[]> => {
    return api.get<LLMProvider[]>('/llm-providers');
  },

  /**
   * Update provider configuration (model, temperature)
   */
  update: (id: number, data: UpdateProviderRequest): Promise<LLMProvider> => {
    return api.patch<LLMProvider>(`/llm-providers/${id}`, data);
  },

  /**
   * Set a provider as active via app_settings
   */
  activate: (id: number): Promise<LLMProvider> => {
    return api.post<LLMProvider>(`/llm-providers/${id}/activate`, {});
  },
};
